/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaAddIrideDto } from '../../models/selettiva-add-iride-dto';
import { SingleResponseIridePostDto } from '../../models/single-response-iride-post-dto';

export interface ApiWsBridgeAlertcallPost$Params {
    /**
     * application/json
     */
    body: SelettivaAddIrideDto;
}

export function apiWsBridgeAlertcallPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiWsBridgeAlertcallPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<SingleResponseIridePostDto>> {
    const rb = new RequestBuilder(rootUrl, apiWsBridgeAlertcallPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'Alert call to add');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<SingleResponseIridePostDto>;
        }),
    );
}

apiWsBridgeAlertcallPost.PATH = '/api/ws-bridge/alertcall';
